import { UnavailableReason } from "_shared/_api/by-ids/by-ids-result";

/**
 * What a roster says in place of a person's details when the directory did not return them.
 *
 * The directory answers each id it was asked for (`individuals-by-userids`), so a row knows why:
 * the person has no profile, or they have one and this viewer may not see it. A row the directory
 * has not answered for yet keeps the general wording.
 */
export function unavailableProfileText(reason?: UnavailableReason): string {
  if (reason === "missing") return "No Attorney Hub profile";
  if (reason === "unauthorized") return "No access to this profile";
  return "Profile unavailable";
}
